export default id => ({
    visible: false,
    id: id,
    init() {
      this.$watch("visible", value => {
        if (value === true) {
          document.body.classList.add("overflow-hidden");
        } else {
          document.body.classList.remove("overflow-hidden");
        }
      });
    },
    show() {
      this.visible = true;
      if (window.Livewire) {
        window.Livewire.emit("modalOpened", this.id);
      }
    },
    hide() {
      this.visible = false;
      if (window.Livewire) {
        window.Livewire.emit("modalClosed", this.id);
      }
    },
    trigger: {
      ["@open-modal.window"](e) {
        if (e.detail == this.id) {
          this.show();
        } else {
          // Auto-hide when other modals are visible?
          this.hide();
        }
      },
      ["@close-modal.window"](e) {
        if (e.detail == this.id) {
          this.hide();
        }
      }
    }
});